var $     = require('./jCube');
var Const = require('../defines');

var FormRenderer = require('./form-renderer');

require('./ui/remodal');
require('./ui/mask');
require('./ui/spinner');
require('./ui/validate');

$.createModal = function(data, simple) {

    var content = data['content'] || '',
        title = !$.isEmptyValue('title', data) ? '<h3 class="icform-header-title">' + data['title'] +'</h3>' : '',
        subtitle = !$.isEmptyValue('subtitle', data) ? '<p class="icform-header-subtitle">' + data['subtitle'] +'</p>' : '';

    var flag_header_simple =
        typeof simple !== 'undefined' ? simple :
            typeof data['simple'] !== 'undefined' ? data['simple'] : true;

    var class_header_simple = flag_header_simple ? 'header-simple' : '';

    var modal = document.createElement('div');
    modal.setAttribute('id', 'icform-modal-info');
    modal.setAttribute('data-remodal-id', 'icform-modal-info');
    modal.className = data['className'] || 'remodal icform-modal';

    modal.innerHTML =
        '<div class="icform-header ' + class_header_simple + '">' +
        title + subtitle +
        '<div class="icform-header-buttons"><button class="icform-button-close" data-remodal-action="close"></button></div>' +
        '</div>' +
        '<div class="icform-content">' + content + '</div>' +
        '<div class="icform-footer"></div>';

    return modal;
};

$.fn.appendRules = function() {

    $('.file-maxsize-1m').rules("add", {
        filesize: 10000000
    });

    $('.file-type-img').rules("add", {
        extension: "jpg|jpeg|png|gif"
    });

    $('.file-type-pdf').rules("add", {
        extension: "pdf"
    });

    return this;
};

$.fn.formRender = function( token, data ) {
    var form;

    if(this.length == 0) return this;

    form = new FormRenderer(this[0], data);
    $(form).append('<input type="hidden" name="token" value="' + token + '" />');

    // return $(form);
    return this;
};

$.fn.buildForms = function(instance) {

    if(!this.length) return;

    var _this = this;

    $(_this).each(function(i, elem) {

        var token = $(elem).data('form-token');

        if(!token) return;

        var _v = '_' + token.replace(/[^0-9a-zA-Z]/g, "", token);

        // if form data isset in html
        if(typeof window[_v] != 'undefined' && window[_v].length > 0){
            buildForm(token, JSON.parse(window[_v])['data']['RegistrationForm']);

        } else {
            // else load one from api server
            instance.sendApi({
                url: instance.getApiUrl() + "/registration/getForm",
                data: { token: token },
                success: function(response) {
                    buildForm(token, response['data']['RegistrationForm']);
                }
            });
        }

        function buildForm(token, data) {

            var _modal = $.createModal({
                content: '<form method="post" enctype="multipart/form-data"></form>',
                className: 'icform-static'
            });

            elem.appendChild(_modal);

            $(_modal).find('form')
                .formRender(token, data)
                .maskFields()
                .labelAnim();
        }
    });
};

$.fn.clearForm = function(){
    var _form = $(this);

    _form.find("input[type=text], textarea").val("");

    _form.find(Const.selPromocode).removeAttr('readonly');
    _form.find(Const.selPromocodeBtn).prop("disabled", false);
    _form.find(Const.selPromocodeInfo).html('');

    _form.labelAnim();
};

$.fn.maskFields = function(){

    //=== mask phone ===
    var target = $(this).find( Const.selMaskPhone ),
        masks = ['(000) 000-00-00', '+00 (000) 000-00-00'],
        mask = masks[0];

    var mask_options = {
        onKeyPress: function(cep){
            mask = (cep.length > 1 && cep.charAt(1) != '0') ? masks[1] : masks[0];
            target.mask(mask, mask_options);
        }
    };
    target.mask(mask, mask_options);

    return this;
};

/**
 * Label Animation
 * https://jsfiddle.net/andrey90vs/q9ht9ww9/
 */
$.fn.labelAnim = function( options ) {

    var settings = $.extend({}, options),
        label,
        ph;

    function getLabel(input) {
        // return $(input).parent().find('label');
        return $("label[for='"+$(input).attr("id")+"']");
    }

    function makeId() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        for( var i=0; i < 5; i++ )
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

    function resetLabel(label){
        if( $(this).val() == '' ) {
            label.removeClass('active');
        }
        label.removeClass('focusIn');
    }

    this.find("input[type=text], textarea").each( function() {

        if( $(this).attr('id') === undefined ) {
            $(this).attr('id', makeId());
        }

        label = getLabel($(this));

        if( label.length == 0 ) {

            return;

            // if( $(this).attr('placeholder') !== undefined ) {
            //     ph = $(this).attr('placeholder');
            //     $(this).attr('placeholder', '');
            //     $(this).parent().prepend('<label for='+ $(this).attr('id') +'>'+ ph +'</label>');
            // }

        } else {
            $(this).attr('placeholder', '');

            if(label.attr('for') === undefined ) {
                label.attr('for', $(this).attr('id'));
            }

            resetLabel(label);
        }

        $(this)
            .on('focus', function() {
                var _label = getLabel($(this));
                _label.addClass('active focusIn');
            })
            .on('focusout', function() {
                var _label = getLabel($(this));
                if( $(this).val() == '' ) {
                    _label.removeClass('active');
                }
                _label.removeClass('focusIn');
            });

        // if($(this).hasClass("no-animate")){
        //     var l = getLabel($(this));
        //     l.addClass("no-animate");
        // }
    });

    return this;
};